import type React from 'react'
import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

interface PortalProps {
  children: React.ReactNode
  targetId?: string // Optional target ID, defaults to 'modal-root'
}

export const Portal = ({ children, targetId = 'modal-root' }: PortalProps) => {
  const [portalNode, setPortalNode] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const element = document.getElementById(targetId)
    if (element) {
      setPortalNode(element)
    } else {
      console.error(`Portal target element with ID "${targetId}" not found.`)
      setPortalNode(null)
    }
  }, [targetId])

  if (!portalNode) {
    return null
  }

  return ReactDOM.createPortal(children, portalNode)
}

// Default export or named export depending on project conventions
export default Portal
